import { useCallback } from "react";
import { useMutation } from "@apollo/client/react";
import { gql } from "../__generated__";
import { getLytraSentryContext } from "../lib/sentryContext";

const RECORD_FEEDBACK_MUTATION = gql(`
  mutation RecordFeedback(
    $message: String!
    $sentryEventId: String!
    $conversationId: UUID
    $chatConversationId: UUID
  ) {
    feedbackRecord(
      message: $message
      sentryEventId: $sentryEventId
      conversationId: $conversationId
      chatConversationId: $chatConversationId
    )
  }
`);

/**
 * The Sentry feedback widget's `onSubmitSuccess`: copies the report onto the
 * Langfuse sessions of the conversations the user was looking at, so it shows
 * up next to the traces it is about. Fire-and-forget: the report already
 * reached Sentry, so a failed copy is not the user's problem.
 */
export function useRecordFeedback(): (data: { message: string }, eventId: string) => void {
  const [record] = useMutation(RECORD_FEEDBACK_MUTATION);
  return useCallback(
    (data, eventId) => {
      const { conversationId, chatConversationId } = getLytraSentryContext();
      if (!conversationId && !chatConversationId) return;
      record({
        variables: {
          message: data.message,
          sentryEventId: eventId,
          conversationId,
          chatConversationId,
        },
      }).catch((error: unknown) => {
        console.warn("Failed to copy feedback to Langfuse", error);
      });
    },
    [record],
  );
}
